import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import type { Translatable } from "app/pages/sales-intelligence/types";

const appsSearchI18nKeys = {
    searchTextPlaceholder: "si.find_apps.table.search.placeholder",

    columnPickerTitle: (appOs?: AppOperatingSystem) => `si.apps.column-picker.title${appOs ? `.${appOs}` : ""}`,

    cell: {
        appLinkTooltipText: "si.find_apps.table.column.tooltip.app-link",

        companyAppsLabel: (count: number): Translatable => ({
            key: `si.leads-search.table.cell.company-apps.count.${count > 1 ? "multiple" : "single"}`,
            replacements: { count },
        }),

        businessModelsLabel: (option: string) => `si.find_apps.filters.business-models.option.${option}`,
    },

    lockedStateTitle: "si.apps.locked-state.title",
    lockedStateSubtitle: "si.apps.locked-state.subtitle",

    upgradeBannerHeader: "si.apps.upgrade-banner.header",
    upgradeBannerTitle: "si.apps.upgrade-banner.title",
    upgradeBannerSubtitle: "si.apps.upgrade-banner.subtitle",
} as const;

export default appsSearchI18nKeys;
